import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '../hooks/useAuth';
import { loginPathFor } from '../lib/login-path';

export function LoginRedirect(): React.ReactElement {
  const { sessionEnded } = useAuth();
  const location = useLocation();
  return <Navigate to={loginPathFor(location, sessionEnded)} replace />;
}
